export default __webpack_public_path__ + "static/media/milestone 800.eb894e62.svg";